let metaList = [];
const link_list = {
    routePath: 'notifications',
    title: 'Active Notifications',
    customDashlet: 'Active',
    search: {
        //read:0,
    },
    sort: {
        order: 'DESC',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }